module.exports = __webpack_public_path__ + "static/img/wb700bb.e795808.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wb700bb.jpg
// module id = igMa
// module chunks = 0